export const BRAND_LOGO_MAX_BYTES = 2 * 1024 * 1024;

const ALLOWED_LOGO_TYPES = new Set(["image/png", "image/svg+xml"]);

export function validateBrandLogoFile(file) {
  if (!file) return "format";
  const type = String(file.type || "").toLowerCase();
  const name = String(file.name || "").toLowerCase();
  const byExt = name.endsWith(".png") || name.endsWith(".svg");
  if (!ALLOWED_LOGO_TYPES.has(type) && !byExt) return "format";
  if (file.size > BRAND_LOGO_MAX_BYTES) return "size";
  return null;
}

export function readBrandLogoDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ""));
    reader.onerror = () => reject(reader.error || new Error("read failed"));
    reader.readAsDataURL(file);
  });
}
